<template>

    <img :class="{ disabled, little }"
         :src="dynamicToggle"
         class="checkbox"
         @click="toggle"/>

</template>

<script>

export default {

    name: 'checkbox',

    props: {

        checked: {
            type: Boolean,
            default: false
        },

        image: {
            type: String,
            default: 'selected'
        },

        disabled: {
            type: Boolean,
            default: false
        },

        line: {
            type: Boolean,
            default: false
        },

        little: {
            type: Boolean,
            default: false
        },

        landingStyle: {
            type: Boolean,
            default: false
        },

        consentStyle: {
            type: Boolean,
            default: false
        }
    },

    watch: {

        checked: function (data) {
            this.value = data
        }

    },

    computed: {

        dynamicToggle: function () {

            if (this.disabled) {

                return '/img/icons/alert-grey.svg'

            }

            if (this.landingStyle) {

                return this.value ? '/img/inputs/checkbox-checked.svg' : '/img/inputs/checkbox-notchecked-landing.svg'
            }


            if (this.consentStyle) {

                return this.value ? '/img/inputs/check-square-fill-green.svg' : '/img/inputs/check-square-empty-green.svg'

            }

            if (this.line) {

                return '/img/inputs/checkbox-line.svg'

            } else {

                const checkboxEmpty = this.isDesktop() ? '/img/inputs/checkbox-empty-desktop.svg' : '/img/inputs/checkbox-unchecked.svg'
                return this.value ? '/img/inputs/check-square-blue.svg' : checkboxEmpty

            }


        }

    },

    data() {

        return {
            link: '/icones/checkbox-empty.svg',
            value: false
        }

    },

    mounted() {
        this.value = this.checked
    },

    methods: {

        toggle() {
            if (!this.disabled) {
                this.value = !this.value
                this.$emit('change', this.value)
            }
        },

        isDesktop: function () {
            return this.$mq === 'lg'
        }
    }

}

</script>

<style lang="scss" scoped>

.checkbox {
    cursor: pointer;
    height: 24px;
    width: 24px;
}

.disabled {
    opacity: 0.5;
}

.little {
    width: 16px;
    height: 16px;
    @media screen and (min-width: $above-tablet-length) {
        width: 24px;
        height: 24px;
    }
}

</style>
